/*
 * @Description:
 * @Author: zhang lin
 * @Date: 2022-11-08 17:23:41
 * @LastEditTime: 2022-11-30 18:16:04
 * @LastEditors: zhang lin
 * @FilePath: /ops-manager-frontend/src/components/ExtAndApp/messages.js
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  extService: '扩展组件',
  app: 'APPs',
});
